var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStatusUpdate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_status_update",
    d: "M17.941,6.9a1.286,1.286,0,0,0-1.066-.91l-4.784-.661L10.2.8A1.3,1.3,0,0,0,7.8.8L5.907,5.325l-4.784.661A1.3,1.3,0,0,0,.436,8.25l3.6,3.214L3.3,16.507a1.3,1.3,0,0,0,2.016,1.268L9,15.27l3.683,2.507A1.3,1.3,0,0,0,14.7,16.51l-.741-5.045,3.6-3.214A1.291,1.291,0,0,0,17.941,6.9Z",
    transform: "translate(0 -.003)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStatusUpdate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_status_update.fe47eaf31617b1c74e4010c22e2395ff.svg";